import { Theme } from '@mui/material';
import styled from '@emotion/styled';

type ParamsStyle = {
    theme?: Theme;
}

export const NumberSection = styled('span')(
    ({ theme }: ParamsStyle) => `
        min-width: 30px;
        height: 30px;
        
        display: flex;
        padding-top: .25rem;
        align-items: center;
        justify-content: center;

        line-height: 1;
        font-weight: 700;
        font-size: 1.43rem;

        border-radius: 3.32023px;
        background: rgba(12, 28, 51, 0.2);
        color: ${theme?.palette.primary.main};
`);

export const ContentCards = styled('ul')(
    ({ theme }: ParamsStyle) => `
        display: grid;
        gap: .875rem;
        grid-template-columns: 1fr;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: grid;
            gap: 1rem;
            grid-template-columns: auto auto;
        }
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);